<template>
通讯录
</template>

<script>
export default {
  name: "address"
}
</script>

<style scoped>

</style>